// Device-aware WhatsApp deep-link helper.
// Mobile  -> wa.me/<phone>?text=...
// Desktop -> web.whatsapp.com/send?phone=<phone>&text=...
// `phone` should be in international format WITHOUT a "+" sign (e.g. "919284729088").

export function isMobileDevice() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || navigator.vendor || "";
  return /android|iphone|ipad|ipod|opera mini|iemobile|mobile/i.test(ua);
}

export function buildWhatsAppUrl(phone, text = "") {
  const message = encodeURIComponent(text || "");
  if (isMobileDevice()) {
    return `https://wa.me/${phone}${message ? `?text=${message}` : ""}`;
  }
  return `https://web.whatsapp.com/send?phone=${phone}${
    message ? `&text=${message}` : ""
  }`;
}

export function openWhatsApp(phone, text = "") {
  const url = buildWhatsAppUrl(phone, text);
  window.open(url, "_blank", "noopener,noreferrer");
}
